import React, { Component } from "react";
import "./navbar.scss";
import SideDrawer from "../side-drawer/side-drawer";
import Hamburger from "hamburger-react";
import "./navbar-mobile.scss";
import PropTypes from "prop-types";

class NavbarMobile extends Component {
  state = {
    sideDrawerOpen: false,
  };

  drawerClickHandler = () => {
    this.setState((prevState) => {
      return { sideDrawerOpen: !prevState.sideDrawerOpen };
    });
    this.props.onSideDrawerOpen(this.state.sideDrawerOpen);
  };

  render() {
    let sideDrawer;

    sideDrawer = (
      <SideDrawer
        click={this.drawerClickHandler}
        show={this.state.sideDrawerOpen}
      />
    );

    return (
      <div style={{ height: "100%" }}>
        <div>
          <div className="hamburger-menu">
            <Hamburger
              toggled={this.state.sideDrawerOpen}
              toggle={this.drawerClickHandler.bind(this)}
            />
          </div>
          <header
            className={`d-flex flex-row nav-mobile-container ${
              this.state.sideDrawerOpen ? "bg-blur" : ""
            }`}
          >
            <h1 className="title-4 m-auto logo-mobile">Vipul Zambare</h1>
          </header>
        </div>
        {sideDrawer}
      </div>
    );
  }
}

NavbarMobile.propTypes = {
  onSideDrawerOpen: PropTypes.func.isRequired,
};

export default NavbarMobile;
